import type { App } from "@upsquad/server";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type GlobalSearchResponse = App["~Routes"]["search"][":communityId"]["get"]["response"]["200"];

interface GlobalSearchParams {
	communityId: string;
	q: string;
	limit?: number;
}

export const searchApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		globalSearch: builder.query<GlobalSearchResponse, GlobalSearchParams>({
			query:
				({ communityId, q, limit }): EdenCall<GlobalSearchResponse> =>
				(client) =>
					client.search({ communityId }).get({ query: { q, limit } }),
			keepUnusedDataFor: 30,
		}),
	}),
});

export const { useGlobalSearchQuery } = searchApi;
